import {useTranslation} from "react-i18next";
import {useUser} from "../user/UserContext";
import {UserTranslKey} from "../user/UserTranslKey";
import Page from "../../common/page/Page";
import UserBasicDetailPanel from "../user/UserDetailBasicPanel";


export function ProfilePage() {
    const {t} = useTranslation();
    const user = useUser();

    return (
        <>
            <Page title={t(UserTranslKey.USER_PROFILE_TITLE)}>
                {user && <UserBasicDetailPanel user={user}/>}
            </Page>
        </>
    );
}
